import axios from 'axios';
import Endpoints from '../Endpoints';

export const getRewardConfig = async () => {
    const { data } = await axios.get(Endpoints.Rewards.CONFIG);
    return data.data;
};

export const updateRewardConfig = async (payload) => {
    const { data } = await axios.put(Endpoints.Rewards.CONFIG, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
    });
    return data.data;
};
